import React, { ReactNode, useRef } from 'react'
import styles from './moreOptionsMenu.module.scss'
import { ReactComponent as IconOptions } from 'images/icons/icn_options.svg'
import PopoverMenu from './PopoverMenu'
import cx from 'classnames'

interface Props {
  children: ReactNode
  id: string
  triggerAriaLabel?: string
  isDisabled?: boolean
  controls?: { isOpen: boolean; setIsOpen: (open: boolean) => void }
}

const MoreOptionsMenu = ({
  children,
  id,
  triggerAriaLabel,
  isDisabled = false,
  controls,
}: Props) => {
  const classes = useRef({
    popover: cx(styles.menuWrapper, styles.overrides),
    trigger: cx(styles.menuTrigger, styles.overrides),
    triggerActive: styles.menuTriggerActive,
    triggerDisabled: styles.menuTriggerDisabled,
  })
  return (
    <PopoverMenu
      menuId={id}
      triggerAriaLabel={triggerAriaLabel || 'more options'}
      triggerContent={<IconOptions aria-hidden />}
      classes={classes.current}
      isDisabled={isDisabled}
      controls={controls}
    >
      <ul className={styles.menu}>{children}</ul>
    </PopoverMenu>
  )
}

export default MoreOptionsMenu
